import { Component, h } from '@stencil/core';
import "../.././stories/Components/MessageBubble/ImageMessageBubble/ImageMessageBubble"
@Component({
  tag: 'chat-image-message-bubble',
  shadow: true
})
 class ChatImageMessageBubble {

  render() {
    return (
      <div>
        <image-message
          bgColor='#EFF1FA'
          imageSrc='https://i.etsystatic.com/7251436/r/il/4fc56c/5398499035/il_570xN.5398499035_rnzx.jpg'
          width='200px'
          height='fit-content'
          padding='10px 10px 15px 10px'
          borderRadius="6px"
          time={new Date().toISOString()}
        >
        </image-message>
      </div>
    );
  }
}

export { ChatImageMessageBubble };
